import React from 'react';
import PropTypes from 'prop-types';
import { LuTrash2 } from 'react-icons/lu';
import { LoadingSpinner } from 'components/common';
import { RUNNING, standardLabel, toReviewCount, when } from '../compareFormat';

const statusText = (c) => {
  if (RUNNING.includes(c.status)) return 'Comparing…';
  if (c.status === 'failed') return 'Failed';
  const n = toReviewCount(c.stats);
  return n ? `${n} to review` : 'Nothing to review';
};

const statusCls = (c) => {
  if (RUNNING.includes(c.status)) return 'tw-text-sky-700';
  if (c.status === 'failed' || toReviewCount(c.stats)) return 'tw-text-red-700';
  return 'tw-text-emerald-700';
};

// The drafts this user compared, newest first; the open one is highlighted.
const DraftHistory = ({ items, selectedId, onOpen, onDelete, deletingId }) => {
  if (items === null) return <div className="tw-py-6 tw-flex tw-justify-center"><LoadingSpinner size="sm" /></div>;
  if (items.length === 0) return <p className="tw-m-0 tw-py-4 tw-text-[13px] tw-text-slate-500">No draft compared yet.</p>;

  return (
    <ul className="tw-m-0 tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-1">
      {items.map((c) => (
        <li key={c.id} className={`tw-flex tw-items-center tw-gap-1 tw-rounded-lg ${c.id === selectedId ? 'tw-bg-primary-50' : 'hover:tw-bg-slate-50'}`}>
          <button type="button" onClick={() => onOpen(c.id)} aria-current={c.id === selectedId ? 'true' : undefined}
            className="tw-flex-1 tw-min-w-0 tw-text-left tw-px-2 tw-py-1.5 tw-bg-transparent tw-border-0 tw-cursor-pointer">
            <span className="tw-block tw-truncate tw-text-[13px] tw-font-semibold tw-text-slate-700" title={c.sales_filename}>{c.sales_filename}</span>
            <span className="tw-block tw-text-[11px] tw-text-slate-500">
              {when(c.created_at)} · vs {standardLabel(c.template)} · <span className={statusCls(c)}>{statusText(c)}</span>
            </span>
          </button>
          {!RUNNING.includes(c.status) && (
            <button type="button" onClick={() => onDelete(c)} disabled={deletingId === c.id}
              aria-label={`Delete ${c.sales_filename}`} title="Delete this draft and its marked-up copy"
              className="tw-p-1.5 tw-mr-1 tw-rounded tw-bg-transparent tw-border-0 tw-text-slate-400 hover:tw-text-red-600 disabled:tw-opacity-50 tw-cursor-pointer">
              {deletingId === c.id ? <LoadingSpinner size="sm" /> : <LuTrash2 size={14} />}
            </button>
          )}
        </li>
      ))}
    </ul>
  );
};

DraftHistory.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  selectedId: PropTypes.number,
  onOpen: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  deletingId: PropTypes.number,
};

export default DraftHistory;
